import React, { useState, useCallback } from 'react';
import V2Button from '../../../components/button/v2_Button';
import V2Icon from '../../../components/icon/v2_Icon';
import { isWorkEmail } from '../services/v2AuthService';
import './V2OktaModal.css';

function V2OktaModal({ isOpen, purpose, onClose, onSubmit }) {
  const [oktaEmail, setOktaEmail] = useState('');
  const [oktaError, setOktaError] = useState('');

  const handleSubmit = useCallback(() => {
    const trimmed = oktaEmail.trim();
    if (!trimmed || !trimmed.includes('@')) {
      setOktaError('Please enter a valid email address.');
      return;
    }
    if (!isWorkEmail(trimmed)) {
      setOktaError('Please use your work email address (not Gmail, Yahoo, etc.).');
      return;
    }
    setOktaError('');
    onSubmit(trimmed, purpose);
  }, [oktaEmail, purpose, onSubmit]);

  if (!isOpen) return null;

  return (
    <div className="v2-okta-modal__overlay" onClick={onClose} role="presentation">
      <div
        className="v2-okta-modal__panel"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="v2-okta-modal-title"
      >
        <div className="v2-okta-modal__header">
          <h2 id="v2-okta-modal-title" className="v2-okta-modal__title">
            {purpose === 'signup' ? 'Sign up with Okta' : 'Sign in with Okta'}
          </h2>
          <button type="button" className="v2-okta-modal__close" onClick={onClose} aria-label="Close">
            <V2Icon name="close" />
          </button>
        </div>

        <p className="v2-okta-modal__description">
          Enter your work email to continue with your organisation's Okta account.
        </p>

        {oktaError && <div className="v2-okta-modal__error">{oktaError}</div>}

        <div className="v2-okta-modal__field">
          <label htmlFor="v2-okta-email" className="v2-okta-modal__label">Work email</label>
          <input
            id="v2-okta-email"
            type="email"
            autoFocus
            value={oktaEmail}
            placeholder="you@company.com"
            className="v2-okta-modal__input"
            onChange={(e) => setOktaEmail(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
          />
        </div>

        <div className="v2-okta-modal__actions">
          <V2Button variant="secondary" onClick={onClose}>Cancel</V2Button>
          <V2Button variant="primary" onClick={handleSubmit}>Continue</V2Button>
        </div>
      </div>
    </div>
  );
}

export default V2OktaModal;
